'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name heroSlider
    * @description Initializes hero slider
    **/

    // Needs only be initialized once per page
    var initializeHeroSliders = function () {
        var $heroSlider = $('#hero-sequence');
        if ($heroSlider.length > 0) {
            var heroSequence = initializeHomeBannerSlider($heroSlider);
            if (heroSequence) {
                var $slides = $heroSlider.find('.slide');
                var $sliderVideos = $slides.find('video');
                initializeHomeBannerVideo($sliderVideos);

                // Must implement manual "pause on hover" functionality.
                // Need to make sure that we don't start autoplay when
                // a video is playing
                $heroSlider.on({
                    mouseenter: function () {
                        var $this = $(this);
                        var $activeSlide = $this.find('.seq-item.seq-in');
                        var hasPlayingVideo = $activeSlide.find('video.playing').length > 0;
                        if (!hasPlayingVideo && !heroSequence.isAutoPlayPaused) {
                            heroSequence.autoPlay.pause();
                        }
                    },
                    mouseleave: function () {
                        var $this = $(this);
                        var $activeSlide = $this.find('.seq-item.seq-in');
                        var hasPlayingVideo = $activeSlide.find('video.playing').length > 0;
                        if (!hasPlayingVideo && heroSequence.isAutoPlayPaused) {
                            heroSequence.autoPlay.unpause();
                        }
                    }
                });

                // Whenever a transition ends (manual or autplay) restart all video states
                heroSequence.animationEnded = resetVideoState.bind(null, $sliderVideos);

                $sliderVideos.on('play', function () {
                    var $this = $(this);
                    heroSequence.autoPlay.pause();
                    $this.addClass('playing');
                });

                $sliderVideos.on('stop ended', function () {
                    var $this = $(this);
                    if (!isInFullScreen()) {
                        heroSequence.next();
                        if (!heroSequence.isMouseOver) {
                            heroSequence.autoPlay.unpause();
                        }
                    }

                    $this.removeClass('playing');
                });
            }

        }
    };

    function initializeHomeBannerVideo($videos) {
        var $videoContainers = $videos.closest('.video-slide');
        $videoContainers.each(function () {
            var $this = $(this);
            $this.on('click', function () {
                var $videoWrapper = $this.find('.hero-banner-video-wrapper');
                var bgColor = $videoWrapper.attr('data-bg-color');
                if (bgColor && bgColor.length > 0) {
                    $videoWrapper.css('background-color', bgColor);
                }

                var $video = $videoWrapper.find('video');
                $this.addClass('activated');
                $video.show().trigger('play');
            });
        });
    }

    function initializeHomeBannerSlider($heroSlider) {
        if ($heroSlider.length > 0) {
            var hasMultipleSlides = $heroSlider.find('.seq-item').length > 1;
            if (hasMultipleSlides) {
                return sequence($heroSlider[0], {
                    autoPlay: true,
                    autoPlayInterval: 5000,
                    autoPlayPauseOnHover: false,
                    pagination: '#hero-sequence .hero-seq-pagination',
                    nextButton: true,
                    prevButton: true,
                    animateCanvas: false,
                    fadeStepWhenSkipped: true
                });
            }
        }

        return null;
    }

    function resetVideoState($videos) {
        $videos.each(function () {
            var $this = $(this);
            var $videoContainer = $this.closest('.video-slide');
            if ($videoContainer.length > 0) {
                $videoContainer.removeClass('activated');
            }
            $this.hide();

            this.currentTime = 0;
            this.pause();
        });
    }

    function isInFullScreen() {
        return (document.fullscreenElement && document.fullscreenElement !== null) ||
            (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
            (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
            (document.msFullscreenElement && document.msFullscreenElement !== null);
    }

    // Return an object exposing the public items
    return {
        initialize: initializeHeroSliders
    };

}())